<template>
	<v-tabs 
		class="round-card"
		height="34"
		background-color="background-1"
		slider-color="primary">
		<v-tab key="Campi" ripple class="secondary-tab">
			Campi
		</v-tab>
		<v-tab key="Azioni" ripple class="secondary-tab">
			Azioni
		</v-tab>
        <v-tab key="Altro" ripple class="secondary-tab">
			Altro
		</v-tab>

		<v-tab-item class="background-1 pt-3 pb-offset" key="Campi">
			<v-row class="ma-0">
				
				<v-col class="pa-0 pt-2" cols="12">
					<fields-selector model-def="container"></fields-selector>
				</v-col>

			</v-row>
			<v-tabs 
				class="tabs-pill mt-4"
				height="34"
				background-color="background-1"
				slider-color="primary">
				<v-tab key="Campi" ripple class="secondary-tab">
					Campi
				</v-tab>
		
				<v-tab-item class="pb-offset background-1 pt-3" key="Campi">
					<v-row class="ma-0 pb-offset">
						
						<v-col class="pa-0 pt-2" cols="12">
							<fields-selector model-def="containermovement" audit></fields-selector>
						</v-col>
		
					</v-row>
				</v-tab-item>
				
			</v-tabs>
		</v-tab-item>
		
		<v-tab-item class="background-1 pt-3 pb-offset" key="Azioni">
			<v-row class="ma-0">
				
				<v-col class="pa-0 pt-2" cols="12">
					<actions-selector model-def="container"></actions-selector>
				</v-col>

			</v-row>
		</v-tab-item>

		<v-tab-item class="background-1 pt-3 pb-offset" key="Commissioni">
			<v-row class="ma-0">
				<agribios-options></agribios-options>
			</v-row>
		</v-tab-item>

	</v-tabs>
</template>
<script>

import FieldsSelector from '@/components/common/FieldsSelector'
import ActionsSelector from '@/components/common/ActionsSelector'
import AgribiosOptions from './AgribiosOptions.vue'

	export default {
		name:'orders-settings',
        components: {
			FieldsSelector,
			ActionsSelector,
            AgribiosOptions,
        },		
		data() {
			return {

			}
		},
	}
  </script>
